'use strict';

// Import Libraries
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
// Import JSX Modules
import screenAndStyle from '../_utils/screen-and-style';
import MobileDeliveryOptionFilter from './mobile-delivery-option-filter';
import { builderDispatch, ShelfUI } from '../_utils/ui';

// Import JS Modules
import translate from '../_utils/tools/translate';

// -----------------------------------------------------------
//  MobileDeliveryOptionFilters
// -----------------------------------------------------------
const MobileDeliveryOptionFilters = ({ options, facets, selectedOptions }) => {

  const [collapsed, setCollapsed] = useState(false);
  const joinedSelectedOptions = (selectedOptions|| []).sort().join('')
  const getSelectedOptions = () => {
    const filterOptions = options.filter(option => selectedOptions.includes(option.key))
    return filterOptions.map(item => item.title).join(', ');
  }

  const handleOptionSelected = options => {
    if (checkOptions(options)) {
      selectedOptions = []
    } else {
      if ((typeof options) === 'undefined'){
        selectedOptions = []
      } else {
        selectedOptions = [options]
      }
    }
    updateOptions(selectedOptions);
  };

  const toggleCollapse = () => {
    setCollapsed(prevState => !prevState);
  };

  if (options.length <= 1) {
    return null;
  }

  const facetKeys = (facets || []).map(facet => parseInt(facet.key));

  const updateOptions = options => {
    builderDispatch.delayedDispatch({
      type: ShelfUI.DELIVERY_OPTION_SELECTED,
      options: options,
    });
  };

  const checkOptions = options => {
    return selectedOptions.includes(options);
  };

  const renderOptions = () => {
    if (collapsed) return null;

    return (
      <div>
        <ul className="list-unstyled checkboxes">
          <MobileDeliveryOptionFilter
            key={0}
            title="Show all"
            OptionKey={[]}
            available={true}
            selected={!joinedSelectedOptions}
            onToggle={handleOptionSelected}
            newUi={true}
          />
          {
            options.map((option, i) => {
              const available = facetKeys.length ? facetKeys.some(facet => option.key === facet) : option.available;
              const selected = selectedOptions.includes(option.key);
              return <MobileDeliveryOptionFilter {...option}
                key={`${i}-${selected ? 'selected' : 'unselected'}`}
                optionkey={option.key}
                available={available}
                selected={selected}
                onToggle={handleOptionSelected}
              />;
            })
          }
        </ul>
      </div>
    );
  };
  return (
    <section className={classNames('accordion-entry accordion-entry-mobile-horizontal-padding filter-delivery-options', { collapsed: collapsed })}>
      <button
        className="p-2 border-0 bg-white w-100 text-left"
        onClick={toggleCollapse}
        aria-label={`${translate('Shipping')} & ${translate('Pickup')}`}
        aria-expanded={!collapsed}
        type='button'
      >
        {translate('Shipping')} & {translate('Pickup')}
      </button>
      {renderOptions()}
      {collapsed && getSelectedOptions()}
    </section>
  );
};

export default MobileDeliveryOptionFilters;
